(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ap-linked-variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ap-linked-variants')) {
    customElements.define('ap-linked-variants', class extends HTMLElement {
      static rules = new Map();
      static images = new Map();
      static cartEnd = 0;
      connectedCallback() {
        if (window.Shopify?.designMode) return;
        const owner = this.constructor;
        const rules = owner.rules;
        const controller = new AbortController();
        const signal = controller.signal;
        let hoverTimer, loadTimer, cartTimer, pendingTimer, cartWatch, visibility;
        this.cleanup = () => { clearTimeout(hoverTimer); clearTimeout(loadTimer); clearTimeout(cartTimer); clearTimeout(pendingTimer); controller.abort(); cartWatch?.disconnect(); visibility?.disconnect(); };
        const settlePending = () => {
          for (const option of this.querySelectorAll('.apv-option--pending, .apv-option--leaving')) option.classList.remove('apv-option--pending', 'apv-option--leaving');
        };
        // Réponse immédiate au toucher : la case choisie prend l'apparence du choix actif pendant que la fiche arrive.
        this.addEventListener('click', (event) => {
          const option = event.target.closest('a.apv-option');
          if (!option || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          settlePending();
          option.parentElement.querySelector('.apv-option--current')?.classList.add('apv-option--leaving');
          option.classList.add('apv-option--pending');
          // Chargement interrompu (bouton Arrêter, retour pendant le chargement) : l'apparence provisoire s'efface.
          clearTimeout(pendingTimer);
          pendingTimer = setTimeout(settlePending, 8000);
        }, {signal});
        // Retour arrière : la page revient de la mémoire du navigateur, on retire cette apparence provisoire.
        window.addEventListener('pageshow', settlePending, {signal});
        const connection = navigator.connection;
        if (this.dataset.prefetch !== 'true' || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
        // Chrome et Edge préparent la fiche entière ; les autres navigateurs, seulement sa photo principale.
        const speculate = HTMLScriptElement.supports?.('speculationrules');
        const gallerySizes = document.querySelector('.product-gallery__media img[fetchpriority="high"]')?.sizes;
        if (!speculate && !gallerySizes) return;
        const keyboardFocus = CSS.supports?.('selector(:focus-visible)');
        let cartEnd = owner.cartEnd, visible = false, settled = false, started = false;
        // Garde-fou : dix fiches préparées par minute et par onglet au plus, pour ne jamais multiplier les requêtes d'un client.
        const allow = (wanted) => {
          try {
            const now = Date.now();
            const recent = JSON.parse(sessionStorage.getItem('apv-prepared') || '[]').filter(time => now - time < 60000);
            const granted = Math.max(0, Math.min(wanted, 10 - recent.length));
            sessionStorage.setItem('apv-prepared', JSON.stringify(recent.concat(Array(granted).fill(now))));
            return granted;
          } catch (error) {
            return 0;
          }
        };
        // Adresse de la fiche visée par un choix ; null pour un autre site ou pour la fiche déjà affichée.
        const address = (anchor) => anchor?.isConnected && anchor.origin === location.origin && (anchor.pathname !== location.pathname || anchor.search !== location.search) && (speculate || anchor.dataset.apvImage) ? anchor.href : null;
        // Photo principale de la fiche visée, avec les largeurs de snippets/media.liquid et les dimensions de la galerie :
        // le navigateur choisit le même fichier que la fiche demandera, et le garde en cache.
        const warm = (anchor) => {
          const base = anchor.dataset.apvImage;
          if (!base || !gallerySizes || owner.images.has(base)) return;
          const image = new Image();
          image.fetchPriority = 'low';
          image.sizes = gallerySizes;
          image.srcset = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200].filter(width => width <= anchor.dataset.apvImageWidth).map(width => `${base}&width=${width} ${width}w`).join(', ');
          owner.images.set(base, image);
        };
        // Chrome télécharge la fiche d'avance, sans exécuter ses scripts, et la garde cinq minutes : passé ce délai, elle peut être préparée de nouveau.
        const prepare = (href, anchor) => {
          warm(anchor);
          if (!speculate) {
            rules.set(href, null);
            return;
          }
          const rule = document.createElement('script');
          rule.type = 'speculationrules';
          rule.textContent = JSON.stringify({prefetch: [{urls: [href]}]});
          document.head.appendChild(rule);
          rules.set(href, rule);
          setTimeout(() => {
            if (rules.get(href) !== rule) return;
            rule.remove();
            rules.delete(href);
          }, 270000);
        };
        // Les trois fiches les plus probables : choix voisins du choix actif dans chaque rangée, puis le set.
        const prepareLikely = () => {
          const ranked = new Map();
          for (const row of this.querySelectorAll('.apv-options')) {
            const options = [...row.children];
            const current = options.findIndex(option => option.hasAttribute('aria-current'));
            options.forEach((option, index) => {
              const href = address(option.matches('a[data-apv-prefetch]') ? option : null);
              if (!href) return;
              const distance = current < 0 ? options.length : Math.abs(index - current);
              const score = option.classList.contains('apv-option--set') ? Math.min(distance, 1.5) : distance;
              if (!ranked.has(href) || score < ranked.get(href)[0]) ranked.set(href, [score, option]);
            });
          }
          const likely = [...ranked].sort((a, b) => a[1][0] - b[1][0]).slice(0, 3).filter(([href]) => !rules.has(href));
          likely.slice(0, allow(likely.length)).forEach(([href, [, option]]) => prepare(href, option));
        };
        const start = () => {
          if (!visible || !settled || started) return;
          started = true;
          prepareLikely();
        };
        const settle = () => { settled = true; start(); };
        const afterLoad = () => { loadTimer = setTimeout(settle, 2500); };
        if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, {once: true, signal});
        // Un appel réussi qui modifie le panier fait effacer par Chrome les fiches déjà préparées : on repart de zéro, une fois les appels terminés.
        // Les photos, elles, restent dans le cache du navigateur.
        if (speculate) {
          cartWatch = new PerformanceObserver((list) => {
            const latest = Math.max(0, ...list.getEntries().filter(entry => /^[^?]*\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(entry.name) && !(entry.responseStatus >= 400)).map(entry => entry.responseEnd));
            if (latest <= cartEnd) return;
            cartEnd = owner.cartEnd = latest;
            rules.forEach(rule => rule.remove());
            rules.clear();
            clearTimeout(cartTimer);
            cartTimer = setTimeout(() => {
              if (!started) settle();
              else if (!document.hidden) prepareLikely();
            }, started ? 1500 : 400);
          });
          cartWatch.observe({type: 'resource', buffered: true});
          // Au retour sur l'onglet, les fiches effacées ou expirées entre-temps sont préparées de nouveau.
          document.addEventListener('visibilitychange', () => { if (!document.hidden && started) prepareLikely(); }, {signal});
        }
        visibility = new IntersectionObserver((entries) => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          visibility.disconnect();
          visible = true;
          start();
        }, {rootMargin: '300px 0px'});
        visibility.observe(this);
        // Au survol, au clavier ou au clic de souris, la fiche visée est préparée ; seul le clic passe outre le garde-fou.
        const prepareOnIntent = (event) => {
          const anchor = event.target.closest('a[data-apv-prefetch]');
          const href = address(anchor);
          if (href && !rules.has(href) && (event.type === 'pointerdown' || allow(1))) prepare(href, anchor);
        };
        this.addEventListener('pointerover', (event) => {
          if (event.pointerType === 'touch') return;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(prepareOnIntent, 120, event);
        }, {signal});
        this.addEventListener('pointerout', () => clearTimeout(hoverTimer), {signal});
        this.addEventListener('focusin', (event) => { if (keyboardFocus && event.target.matches(':focus-visible')) prepareOnIntent(event); }, {signal});
        // Sur écran tactile, l'appui ne prépare rien : un défilement commence souvent le doigt posé sur un choix.
        this.addEventListener('pointerdown', (event) => { if (event.pointerType !== 'touch') prepareOnIntent(event); }, {signal});
      }
      disconnectedCallback() { this.cleanup?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
